import { Box } from "@mui/material";

import { PolicyStatusChip } from "./PolicyStatusChip";
import { LoanChip } from "./LoanChip";
import { GuaranteedConversionFactorsChip } from "./GuaranteedConversionFactorsChip";
import { LegalLimitChip } from "./LegalLimitChip";
import { Tikun190Chip } from "./Tikun190Chip";
import { Product } from "../../../interfaces/DTO/mislaka_xml_models";

interface Props {
  product: Product;
  showConversionFactors?: boolean;
}

export const PolicyStatuses = ({ product, showConversionFactors = false }: Props) => {
  const policies = product.policies_or_accounts || [];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        minHeight: 48,
        alignItems: "flex-start",
        py: 1,
      }}
    >
      <PolicyStatusChip policies={policies} showCount={false} />
      <LoanChip policies={policies} />
      <LegalLimitChip policies={policies} />
      <Tikun190Chip policies={policies} product={product} />
      {showConversionFactors && <GuaranteedConversionFactorsChip products={[product]} />}
    </Box>
  );
};
